import React, { useState } from 'react';
import * as yup from 'yup';

import { WrapPage } from '../WrapPage';
import { Typography } from '@mui/material';
import { CustomInput } from '../../../../components/CustomInput';
import { CustomButton } from '../../../../components/CustomButton';
import { useFormik } from 'formik';
import { resetPassword } from '../../../../api/auth';

export const EnterEmailPage = () => {
  const [messageRes, setMessageRes] = useState();
  const [status, setStatus] = useState(false);

  const { handleSubmit, values, handleChange, errors, isSubmitting, resetForm, handleBlur } =
    useFormik({
      initialValues: {},
      validationSchema: yup.object({
        email: yup.string().required('Обязательное поле').email('Некорректный email')
      }),
      validateOnChange: false,
      validateOnBlur: true,
      onSubmit: (values) => {
        if (isSubmitting) {
          let formData = new FormData();
          formData.append('email', values.email);
          resetPassword(formData)
            .then((res) => {
              setMessageRes(res.message);
              setStatus(res.status);
              if (res.status) {
                resetForm();
              }
            })
            .catch((err) => console.log(err));
        }
      }
    });

  return (
    <WrapPage iconRight>
      <form onSubmit={handleSubmit}>
        <Typography
          variant="h2"
          sx={{
            color: 'text.primary',
            marginBottom: '30px',
            lineHeight: '48px',
            fontSize: '3rem'
          }}>
          Восстановите пароль
        </Typography>
        {!status && (
          <>
            <Typography
              variant="subtitle2"
              sx={{ color: 'text.primary', marginBottom: '16px', fontWeight: '400' }}>
              Для восстановления пароля введите e-mail, указанный при регистрации.
            </Typography>
            <CustomInput
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors['email']}
              helperText={errors['email']}
              placeholder="E-mail"
              sx={{ width: '100%' }}
            />
          </>
        )}
        <Typography sx={{ color: `${!status && 'red'}`, marginTop: '10px' }}>
          {messageRes === 'Некорректный адрес электронной почты.'
            ? 'В системе нет пользователей с таким адресом электронной почты. Попробуйте еще раз.'
            : messageRes}
        </Typography>
        {!status && (
          <CustomButton type="submit" size="large" variant="contained" sx={{ marginTop: '30px' }}>
            Далее
          </CustomButton>
        )}
      </form>
    </WrapPage>
  );
};

export default EnterEmailPage;
